// Godsmode: whether the log shows. The log is behind a button beside Menu,
// and it is closed at first. Added 2026-10-12. Garrett: "I doon't think the
// log needs the full real estate here, but rather we could have a system
// where one could expand the log and in doing so the opponent ui has a
// compact view, but otehrwise the log is tucked away". A match with a wheel
// shows its log at all times and does not read this.

import { createStore } from '../lib/store';

export const logOpenStore = createStore(false);

export const toggleLog = (): void => logOpenStore.set((open) => !open);

export const closeLog = (): void => logOpenStore.set(false);
